// extracted by mini-css-extract-plugin
module.exports = {"content":"CompetitionHeader_content__nwUfW","banner":"CompetitionHeader_banner__ouQc2","btn":"CompetitionHeader_btn__aW2AX","pos":"CompetitionHeader_pos__uMDzK"};